export default function (controller) {
  $('[data-toggle="tooltip"]').tooltip()
}
